export default "__VITE_ASSET__BClZ4MsG__"